<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1>Akun</h1>
            </div>
        <div class="section-body">
            <div class="row justify-content-md-center">
                <div class="col-12 col-md-4 col-lg-4">
                    <div class="card">
                        <div class="card-header">
                            <h4>Buat Akun Baru</h4>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <label>*Nama Akun</label>
                                <input type="text" v-model="nama_akun" required class="form-control">
                            </div>
                            <div class="form-group">
                                <label>*Nomor Akun</label>
                                <input type="text" v-model="nomor_akun" required class="form-control">
                            </div>
                            <div class="form-group">
                                <label>*Kategori Akun</label>
                                <select required id="kategori_akun" class="form-control select2">
                                       <option v-for="option in kategoriList" v-bind:key="option.id_kategori_coa" :value="option.id_kategori_coa">{{ option.nama_kategori }}</option>
                                </select>
                            </div>
                            <div v-if="type == 'new'" class="form-group">
                                <label>Saldo Awal</label>
                                <input type="text" v-model="saldo_awal" required class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Deskripsi</label>
                                <textarea class="form-control" required v-model="deskripsi" ></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <button v-if="type=='new'" @click="submit('normal')" class="btn btn-primary">Buat Coa</button>
                    <button v-if="type=='edit'" @click="submit('normal')" class="btn btn-primary">Update Coa</button>
                    <button v-if="type=='edit'" @click="hapus()" class="btn btn-danger">Hapus Coa</button>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>

<style>
.vs__dropdown-toggle {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: flex;
    padding: 7px 4px 7px 4px;
    background: none;
    border: 1px solid #e4e6fc;
    border-radius: 4px;
    white-space: normal;
    min-width: 360px;
}
.vs__actions {
    padding: 0px 6px 0 3px;
}
.vs__clear {
    display:none;
}
.vs__dropdown-menu {
    background-color: white;
    border: 1px solid #aaa;
    border-radius: 4px;
    box-sizing: border-box;
    display: block;
    position: absolute;
    z-index: 3000;
    max-height: 120px !important;
}
</style>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)

export default {
    data() {
        return {
            id_coa : '',
            coaDetail : [],
            type : 'new',
            nama_akun : '',
            nomor_akun : '',
            kategori_akun : '',
            saldo_awal : 0,
            deskripsi : '',
            kategoriList : []
        }
    },
    mounted() {
        this.init();
        window.$(document).ready(function(){
            setTimeout(function(){ 
                $("#kategori_akun").select2();
             }, 100);
            
        });
    },
    methods: {
        init: function()
        {
            // get kategori COA list
			this.$http.post("Datalist/getKategoriCoa").then(result => {
			    if(result.data.code == '00') {
                    alert('failed get kategori COA')
                }
                else {
                    this.kategoriList = result.data.detail
                }
			}, error => {
				console.log('gk ok')
				context.errors = errors;
            });

            if(this.$route.params.id_coa != null) {
                this.type = 'edit'
                this.id_coa = this.$route.params.id_coa
                this.$http.post("Finance/getCoaDetail/"+this.id_coa).then(result => {
                    if(result.data.code == '00') {
                        alert('failed get Detail')
                    }
                    else {
                        this.coaDetail = result.data.detail
                        this.nama_akun = this.coaDetail.nama_akun
                        this.nomor_akun = this.coaDetail.kode_akun
                        this.deskripsi = this.coaDetail.deskripsi
                        this.kategori_akun  = this.coaDetail.id_kategori

                        var kc = parseInt(this.kategori_akun);
                        
                        setTimeout(function(){ 
                            $("#kategori_akun").val(kc).trigger('change');
                        }, 200);
                    }
                }, error => {
                    console.log('gk ok')
                    context.errors = errors;
                });
            }
        },
        submit: function(type) {
            
            this.kategori_akun = $("#kategori_akun").select2('val')
            
            if(this.nama_akun == '' || this.nomor_akun == '') {
                this.$parent.toastr = {
                    title : 'Error',
                    message: 'Nama Akun / Nomor Akun harus diisi !',
                    type : 'error'
                }
                return false
            }

            var formsub = new FormData();
            var objThis = this;
            formsub.append('type',this.type)
            formsub.append('nama_akun',this.nama_akun);
            formsub.append('nomor_akun',this.nomor_akun);
            formsub.append('deskripsi',this.deskripsi);
            formsub.append('kategori_akun', this.kategori_akun);
            formsub.append('saldo_awal',this.saldo_awal);

            if(this.type == 'edit') {
                formsub.append('id_coa',this.id_coa);
                formsub.append('saldo_awal','');
            }

            this.$http.post("Finance/updateCoa", formsub).then(result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'Data Coa telah terupdate !',
                        type : 'success'
                    }
                    if(type == 'normal'){
                        this.$router.replace({ path : '/finance/daftar-akun' })
                        
                    }else {
                        this.$parent.reRendering(); 
                    }
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Gagal update Coa !',
                        type : 'error'
                    }          
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
			});
        },
        hapus: function()
        {

        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/daftar/FormAkun.vue